import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    showThematicCounseling() {
      return (
        this.$auth.user &&
        this.partnerData &&
        this.partnerData.categories &&
        this.partnerData.categories.indexOf(1) !== -1 &&
        this.$auth.user.benefit &&
        this.$auth.user.benefit.active
      );
    }
  },
  methods: {
    async thematicCounselingGoToForm() {
      await this.$router.push(
        this.$localePath({
          name: this.isPutinSucks ? 'dashboard' : 'thematicCounselling',
          hash: this.isPutinSucks ? '' : '#thematic_counselling_form',
          query: this.isPutinSucks
            ? {
                dfn: 'Question'
              }
            : ''
        })
      );
    }
  }
};
